var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 22",
    style: {
      enableBackground: "new 0 0 27 22"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,1.5c1-0.6,2.2-0.9,3.9-0.7l0,0c3,0.3,5.3,3.1,5.3,6.2c0,4.6-2.4,8-5.1,10.3c-2.8,2.3-5.8,3.5-6.9,3.9l0,0 l0,0c-0.1,0-0.2,0-0.4,0v0l0,0c-1.1-0.4-4.2-1.6-6.9-3.9C3.6,15,1.2,11.7,1.3,7c0-3.2,2.1-5.9,5.3-6.2c1.7-0.2,2.9,0.1,3.9,0.7 c1,0.6,1.8,1.6,2.3,2.7l0.7,1.3l0.7-1.3C14.8,3.1,15.5,2.2,16.5,1.5z",
    fill: "none",
    stroke: "#E7E6F0",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.b629e7891794a2c6f826b212da06b17c.svg";
export { ForwardRef as ReactComponent };